<template>
  <div class="row">
    <div class="col-12">
      <table class="table table-bordered doctor-education" v-if="dataset.length>0">
        <tbody>
          <tr v-for="(d, index) in dataset" :key="index">
            <td v-if="index!=editIndex">
              <div class="doctor-education-element">
                <i class="fa fa-graduation-cap" aria-hidden="true"></i> 
                <span>{{d}}</span>
              </div>
            </td>
            <td class="edit-element" v-if="index!=editIndex"><i class="fa fa-pencil-square-o" @click="editData(index)"></i></td>

            <td v-if="index==editIndex">
              <div class="doctor-education-input">
                <input type="text" class="form-control" ref="editData" v-model="dataset[index]">
                <div class="confirm">
                  <button class="btn btn-success" @click="saveData(index)">{{$t('action_message.ok')}}</button>
                  <button class="btn btn-danger" @click="removeData(index)">{{$t('action_message.remove')}}</button>

                </div>
              </div>
            </td>
            <td class="edit-element" v-if="index==editIndex"><i class="fa fa-pencil-square-o"></i></td>

          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-12">
      <div class="doctor-education-add clearfix">
        <span>{{description}}</span>
        <button class="btn btn-add-edu" @click="addData">+ {{$t('action_message.add')}}</button>
      </div>
    </div>
    <div class="col-12">
      <p class="doctor-eduication-ex"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'doctorArrayInput',
  props: {
    dataset: Array, // ['string' ..]
    description: String
  },
  data () {
    return {
      editIndex: -1
    }
  },
  methods: {
    addData () {
      if (this.editIndex >= 0) return

      this.dataset.push('')
      this.editIndex = this.dataset.length - 1

      // Focus on the input
      let focusDelay = 100
      let refs = this.$refs
      setTimeout(function () {
        refs.editData[0].focus()
      }, focusDelay)
    },
    saveData (index, $event) {
      // save data if the length > 1
      if (this.dataset[index].length <= 1) {
        this.dataset.splice(index, 1)
      }
      this.$emit('update:dataset', this.dataset)
      this.editIndex = -1
    },
    editData (index) {
      this.editIndex = index
      // Focus on the input
      let focusDelay = 300
      let refs = this.$refs
      setTimeout(function () {
        refs.editData[0].focus()
      }, focusDelay)
    },
    removeData (index, event) {
      this.dataset.splice(index, 1)
      this.$emit('update:dataset', this.dataset)
      this.editIndex = -1
    }
  }
}
</script>

<style lang="less">
.doctor-education{

  background-color: #f3f3f3;
  margin-bottom: 10px;

  td{
    border: 1px solid #dde6ea;
  }

  .edit-element{
    width: 50px;
  }

  i {
    color: #555;
  }

  .doctor-education-input{
    .confirm {
      text-align: right;
      margin: 5px 0 0 0;
    }
  }

  .doctor-education-element{
    display: flex;
    i {
      margin: 0 5px;
    }
  }
}
.doctor-education-add{
  padding: 10px 20px;
  border: 1px solid #ddd;
  margin-bottom: 10px;
  border-radius: 5px;

  span{
    float: left;
    padding: 12px 0;
    font-weight: bold;
    font-size: 16px;
    color: #bababa;
  }
  button{
    float: right;
  }

  .btn-add-edu{
    border-radius: 5px;
    color: #fff;
    background-color: #4e9666;
    font-size: 16px;
  }
}
.doctor-eduication-ex{
  color: #bababa;
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// DoctorArrayInput.vue?9fd838ca